export default "__VITE_ASSET__DMNSMli___"